import type { MessageKey } from "../../i18n/keys";
import type { DashboardSettings } from "./queries";

export interface DashboardBlock { id: string; label: string; kind: "module" | "tile" | "chart" | "list" | "camera" }
export const metrics = [
  { key: "active_members", label: "workspace.metric.active_members", permission: "members.read", kind: "tile" },
  { key: "spend_mtd", label: "workspace.metric.spend_mtd", permission: "billing.reports", kind: "tile" },
  { key: "rounds_mtd", label: "workspace.metric.rounds_mtd", permission: "teesheet.read", kind: "tile" },
  { key: "ar_over_60", label: "workspace.metric.ar_over_60", permission: "billing.reports", kind: "tile" },
  { key: "ar_over_90", label: "workspace.metric.ar_over_90", permission: "billing.reports", kind: "tile" },
  { key: "spend_trend", label: "workspace.metric.spend_trend", permission: "billing.reports", kind: "chart" },
  { key: "rounds_trend", label: "workspace.metric.rounds_trend", permission: "teesheet.read", kind: "chart" },
  { key: "members_by_category", label: "workspace.metric.members_by_category", permission: "members.read", kind: "chart" },
  { key: "membership_changes", label: "workspace.metric.membership_changes", permission: "members.read", kind: "chart" },
  { key: "top_spenders", label: "workspace.metric.top_spenders", permission: "billing.reports", kind: "list" },
  { key: "departments", label: "workspace.metric.departments", permission: "billing.reports", kind: "list" },
  { key: "most_rounds", label: "workspace.metric.most_rounds", permission: "teesheet.read", kind: "list" },
] as const satisfies readonly { key: string; label: MessageKey; permission: string; kind: DashboardBlock["kind"] }[];

export function orderedBlocks(blocks: DashboardBlock[], settings?: DashboardSettings): DashboardBlock[] {
  const map = new Map(blocks.map((block) => [block.id, block]));
  const ids = [...new Set([...(settings?.order ?? []), ...blocks.map((block) => block.id)])];
  return ids.flatMap((id) => { const block = map.get(id); return block ? [block] : []; });
}

export function moveBlock(ids: string[], id: string, direction: -1 | 1): string[] {
  const from = ids.indexOf(id), to = from + direction;
  if (from < 0 || to < 0 || to >= ids.length) return ids;
  const copy = [...ids]; [copy[from], copy[to]] = [copy[to]!, copy[from]!]; return copy;
}

export const positionFocus: Record<NonNullable<DashboardSettings["position"]>, string[]> = {
  management: ["reports", "members", "billing", "accounting"], membership: ["members", "portal", "communications"],
  golf: ["teesheet", "pos", "members", "reports"], hospitality: ["frontdesk", "guests", "lodging", "pos"],
  finance: ["accounting", "billing", "expenses", "reports"], operations: ["pos", "guests", "lodging", "reports"], other: [],
};
